import React, { useState, useEffect, useImperativeHandle, forwardRef, useCallback} from 'react'
import st from './index.scss'

export default forwardRef(function Tour(props, ref) {
  const {
    children,
    className,
    list,
    visible = false,
    ...rest
  } = props;

  const [showTour, setShowTour] = useState(false)
  const [active, setActive] = useState(0)

  const [maskRect, setMaskRect] = useState({
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0,
  })

  useEffect(() => {
    if (visible) {
      getRootPosition()
    }
    setActive(0)
    setShowTour(visible)
  }, [visible])

  useEffect(() => {
    if(showTour) {
      document.body.classList.add("body-overflow-hidden");
      setTimeout(()=> {
        getRootPosition()
      })
    }else {
      document.body.classList.remove("body-overflow-hidden");
    }
  }, [showTour]);

  useEffect(() => {
    if (visible) {
      getRootPosition()
    }
  }, [active])

  const getRootPosition = () => {
    const el = document.querySelector(`#${list[active].target}`)
    if(el) {
      const rect = el.getBoundingClientRect()
      setMaskRect(rect)
    }
  }

  useEffect(() => {
    window.addEventListener('resize', getRootPosition, false)
    return () => {
      window.removeEventListener('resize', getRootPosition)
    }
  }, [showTour, active]);

  const maskStyle = () => {
    const { width, height, left, top } = maskRect
    const w = width
    const h = height
    const styles = {
      width: `${w}px`,
      height: `${h}px`,
      top: top,
      left: left,
    }
    return styles
  }

  const maskClose = (e) => {
    setShowTour(false)
  }

  const changeStep = (type) => {
    if (type === 'next') {
      setActive(active + 1)
    } else {
      setActive(active - 1)
    }
  }

  useImperativeHandle(ref, () => ({
    next: ()=> {
      changeStep('next')
    },
    prev: ()=> {
      changeStep()
    },
    close: maskClose
  }))

  return (
    <div {...rest}>
      <div
        className={`${st['tour-masked']}`}
        style={{ display: showTour ? 'block' : 'none' }}
      />
      <div
        className={`${
          showTour ? st['tour-mask'] : st['tour-mask-none']
        }`}
        style={maskStyle()}
      >
        {React.Children.map(children, (child, index) => {
          return active === index ? React.cloneElement(child, {
            index: index,
            style: {
              ...child.props.style,
              position:'relative'
            }
          }) : null;
        })}
      </div>
    </div>
  )
})
